// branding
import appLogo from "../assets/images/brand/documentit-logo.svg";
import appIcon from "../assets/images/brand/app-icon.svg";
import appIconCircle from "../assets/images/brand/app-icon-circle.svg";

// icons
import desktop from "../assets/images/icons/devices-desktop.svg";
import desktopOnline from "../assets/images/icons/devices-desktop-2.svg";
import desktopOffline from "../assets/images/icons/devices-desktop-3.svg";
import rightUp from "../assets/images/icons/right-up.svg";
import devicesCompliant from "../assets/images/icons/devices-compliant.svg";
import deviceNonCompliant from "../assets/images/icons/non-compliant.svg";

const AssetPath = {
  brand: {
    appLogo,
    appIcon,
    appIconCircle,
  },
  icons: {
    desktop,
    desktopOnline,
    desktopOffline,
    rightUp,
    devicesCompliant,
    deviceNonCompliant,
  },
};

export default AssetPath;
